import React from 'react';
import { CheckIcon } from 'lucide-react';
export function WhatYouGetSection() {
  const items = [{
    title: 'Manual completo (PDF descargable)',
    description: 'Guía paso a paso para identificar patrones emocionales heredados.'
  }, {
    title: 'Diario terapéutico',
    description: 'Para trabajar e integrar lo que descubres.'
  }, {
    title: 'Cartas terapéuticas listas para usar',
    description: 'Herramientas prácticas para soltar carga emocional.'
  }, {
    title: 'Ejercicios guiados',
    description: 'Aplicables desde el primer día.'
  }, {
    title: 'Plantillas de autoexploración',
    description: 'Para detectar patrones invisibles.'
  }];
  return <section className="w-full py-20 md:py-28 px-6 bg-beige" data-id="element-224">
      <div className="max-w-3xl mx-auto" data-id="element-225">
        <h2 className="font-playfair text-3xl md:text-4xl lg:text-5xl text-dark text-center mb-14" data-id="element-226">
          ¿Qué recibes exactamente?
        </h2>

        <div className="space-y-6" data-id="element-227">
          {items.map((item, index) => <div key={index} className="flex items-start gap-4 bg-white/60 p-6 rounded-xl border border-dark/5" data-id="element-228">
              <div className="w-8 h-8 rounded-full bg-terracotta/10 flex items-center justify-center shrink-0 mt-0.5" data-id="element-229">
                <CheckIcon className="w-4 h-4 text-terracotta" strokeWidth={3} data-id="element-230" />
              </div>
              <div data-id="element-231">
                <h3 className="font-medium text-dark text-lg mb-1" data-id="element-232">
                  {item.title}
                </h3>
                <p className="text-dark/60 font-light leading-relaxed" data-id="element-233">
                  {item.description}
                </p>
              </div>
            </div>)}
        </div>

        <p className="text-center text-dark/50 font-light text-sm mt-10 tracking-wide" data-id="element-234">
          Acceso inmediato. Todo en formato digital.
        </p>
      </div>
    </section>;
}